import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
const styles = require('./styles.scss')

export interface ProgressBarProps {
  className?: string
  currentStep: number
  totalNumberOfSteps: number
  followupStep?: number
  followupIncrement?: number
}

export const ProgressBar: React.SFC<ProgressBarProps> = ({
  className,
  currentStep,
  followupIncrement = 0,
  followupStep = 0,
  totalNumberOfSteps,
}) => {
  const baseWidth = (currentStep / totalNumberOfSteps) * 100
  const followupWidth = followupStep * followupIncrement
  const width = followupWidth > 100 / totalNumberOfSteps ? baseWidth : baseWidth + followupWidth

  return (
    <ThemeConsumer>
      {({ borderRadiusLarge, colorSecondary }) => (
        <div
          className={classnames(
            className,
            styles.background,
            css`
              border-radius: ${borderRadiusLarge};
            `,
          )}
        >
          <div
            className={classnames(
              styles.bar,
              css`
                background-color: ${colorSecondary};
                width: ${width}%;
              `,
            )}
          />
        </div>
      )}
    </ThemeConsumer>
  )
}
